import React from 'react';
import {
  Create,
  DeleteWithConfirmButton,
  DisabledInput,
  Edit,
  EditButton,
  List,
  SaveButton,
  SimpleForm,
  TextField,
  TextInput,
  Toolbar
} from 'react-admin';

import { defaultListProps } from '~constants/config';
import CustomDatagrid from '~components/CustomDatagrid';
import FieldGroup from '~components/FieldGroup';
import { isRequired } from '~utils/inputValidations';

// Screens shared by the flat translated catalogs (Ámbito, Tema, Tipo, Plazo):
// a name in ES plus optional EN/PT.

function CatalogToolbar(props) {
  return (
    <Toolbar {...props}>
      <SaveButton />
    </Toolbar>
  );
}

function CatalogForm({ children, ...props }) {
  return (
    <SimpleForm {...props} toolbar={<CatalogToolbar />}>
      {children}
      <FieldGroup label="fieldGroups.catalogEs">
        <TextInput source="name" validate={isRequired} />
      </FieldGroup>
      <FieldGroup label="fieldGroups.catalogEn">
        <TextInput source="nameEn" />
      </FieldGroup>
      <FieldGroup label="fieldGroups.catalogPt">
        <TextInput source="namePt" />
      </FieldGroup>
    </SimpleForm>
  );
}

export function CatalogList(props) {
  return (
    <List {...defaultListProps} {...props}>
      <CustomDatagrid rowClick="edit">
        <TextField source="id" />
        <TextField source="nameEs" />
        <TextField source="nameEn" />
        <TextField source="namePt" />
        <DeleteWithConfirmButton label="" />
        <EditButton label="" />
      </CustomDatagrid>
    </List>
  );
}

export function CatalogCreate(props) {
  return (
    <Create {...props}>
      <CatalogForm redirect="list" />
    </Create>
  );
}

export function CatalogEdit(props) {
  return (
    <Edit undoable={false} {...props}>
      <CatalogForm redirect="list">
        <DisabledInput label="Id" source="id" />
      </CatalogForm>
    </Edit>
  );
}
